import { useTheme } from '@mui/material';

export default function BusinessListIntegrationIcon({ size = 24 }: { size?: number }) {
  const theme = useTheme();
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_77572_352599'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_77572_352599)'>
        <path
          d='M9.6 15.2345L10.6537 14.15L8.50375 12L10.6537 9.85L9.6 8.7655L6.3655 12L9.6 15.2345ZM14.4 15.2345L17.6345 12L14.4 8.7655L13.3462 9.85L15.4962 12L13.3462 14.15L14.4 15.2345ZM5.30775 20.5C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V5.30775C3.5 4.80908 3.67658 4.38308 4.02975 4.02975C4.38308 3.67658 4.80908 3.5 5.30775 3.5H9.75775C9.82058 2.94483 10.0629 2.47275 10.4848 2.08375C10.9064 1.69458 11.4115 1.5 12 1.5C12.5948 1.5 13.1032 1.69458 13.525 2.08375C13.9468 2.47275 14.1859 2.94483 14.2423 3.5H18.6923C19.1909 3.5 19.6169 3.67658 19.9703 4.02975C20.3234 4.38308 20.5 4.80908 20.5 5.30775V18.6923C20.5 19.1909 20.3234 19.6169 19.9703 19.9703C19.6169 20.3234 19.1909 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM12.5375 4.13375C12.6792 3.99208 12.75 3.81292 12.75 3.59625C12.75 3.37958 12.6792 3.20042 12.5375 3.05875C12.3958 2.91708 12.2167 2.84625 12 2.84625C11.7833 2.84625 11.6042 2.91708 11.4625 3.05875C11.3208 3.20042 11.25 3.37958 11.25 3.59625C11.25 3.81292 11.3208 3.99208 11.4625 4.13375C11.6042 4.27542 11.7833 4.34625 12 4.34625C12.2167 4.34625 12.3958 4.27542 12.5375 4.13375Z'
          fill={theme.palette.primary.main}
        />
      </g>
    </svg>
  );
}
